<template>
    <div class="vue-algolia-search-container container">
        <ais-instant-search
            :search-client="searchClient"
            :index-name="indexName"
            :routing="routing">
            <div class="row mt-5">
                <div class="col-lg-4">
                    <div class="search-box-wrapper">
                        <h1 class="virtual-h2">{{ searchResultsTxt }}</h1>
                        <ais-search-box
                            :placeholder="searchPlaceholderTxt"
                        ></ais-search-box>
                        <ais-stats>
                            <template v-slot="{ hitsPerPage, nbPages, nbHits, page, processingTimeMS, query }">
                                <p v-html="getTranslatedStats(nbHits, processingTimeMS)"></p>
                            </template>
                        </ais-stats>
                    </div>

                    <ais-configure
                        :hitsPerPage="10"
                        :filters='`field_domain_access:"${activeDomainId}"`'
                    ></ais-configure>
                </div>

                <div class="col-lg-8">
                    <ais-state-results>
                        <template v-slot="{ results: { hits, query } }">
                            <template v-if="hits.length > 0" >
                                <ais-hits>
                                    <template v-slot:item="{ item }">
                                        <div class="row result-item">
                                            <div class="col-12">
                                                <h3><a :href="item.url" :title="readMoreTxt">{{ item.title }}</a></h3>

                                                <ul class="categories-list" v-if="Array.isArray(item.field_category_name)">
                                                    <li v-for="cat in item.field_category_name">{{ cat }}</li>
                                                </ul>

                                                <p
                                                    class="category"
                                                    v-if="! Array.isArray(item.field_category_name) && item.field_category_name" >
                                                    {{ item.field_category_name }}
                                                </p>

                                                <p
                                                    v-if="item._highlightResult && item._highlightResult.rendered_item"
                                                    :inner-html.prop="item._highlightResult.rendered_item.value | truncate(256)"></p>

                                                <p
                                                    v-else-if="item._highlightResult && item._highlightResult.body"
                                                    :inner-html.prop="item._highlightResult.body.value | truncate(256)"></p>

                                                <p
                                                    v-else-if="item._highlightResult && item._highlightResult.field_two_column_text"
                                                    :inner-html.prop="item._highlightResult.field_two_column_text.value | truncate(256)"></p>

                                                <p
                                                    v-else-if="item._highlightResult && item._highlightResult.field_text && item._highlightResult.field_text.value"
                                                    :inner-html.prop="item._highlightResult.field_text.value | truncate(256)"></p>

                                                <p
                                                    v-else-if="item._highlightResult && item._highlightResult.field_text && item._highlightResult.field_text[0]"
                                                    :inner-html.prop="item._highlightResult.field_text[0].value | truncate(256)"></p>

                                                <a :href="item.url" class="cta-link" :title="readMoreTxt">{{ readMoreTxt }}</a>
                                            </div>
                                        </div>
                                    </template>
                                </ais-hits>

                                <ais-pagination></ais-pagination>
                            </template>

                            <template v-else>
                                <div class="row mt-5 mb-5 no-results-row">
                                    <div class="col-12 text-center">
                                        <p>{{ noResultsTxt }} <span class="query">{{ query }}</span>.</p>
                                    </div>
                                </div>
                            </template>

                        </template>
                    </ais-state-results>
                </div>
            </div>
        </ais-instant-search>
    </div>
</template>

<script>
import algoliasearch from 'algoliasearch/lite';
import {history as historyRouter} from 'instantsearch.js/es/lib/routers';
import {simple as simpleStateMapping} from 'instantsearch.js/es/lib/stateMappings';
import 'instantsearch.css/themes/satellite-min.css';

export default {
    name: "AlgoliaSearchContainer",

    props: {
        langCode: {
            type: String,
            default: 'nl'
        },
        activeDomainId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            readMoreTxt: window.Drupal.t('Read more'),
            searchResultsTxt: window.Drupal.t('Search results'),
            searchPlaceholderTxt: window.Drupal.t('Search...'),
            noResultsTxt: window.Drupal.t('No results have been found for:'),
            searchClient: algoliasearch(
                '5YRXPIKU2Y',
                '77dcb6951729290d7dab8cd198462e07',
            ),
            routing: {
                router: historyRouter(),
                stateMapping: simpleStateMapping(),
            },
        };
    },

    computed: {
        indexName() {
            return `vneml_prod_${this.langCode}`
        }
    },

    filters: {
        truncate(value, length) {
            if (_.isEmpty(value)) {
                return '';
            }

            value = value.toString();

            if (value.length > length) {
                return value.substring(0, length) + "...";
            }

            return value;
        }
    },

    methods: {
        getTranslatedStats(results, time) {
            return window.Drupal.t('<span>@results results</span> retrieved in @time ms', {
                '@results': results,
                '@time': time,
            })
        }
    }
}
</script>